import React from "react";
import BiodiversityLayerGroup from "../BiodiversityLayerGroup";

import BiodiversityDashboard from "./Components/BiodiversityDashboard";
import { WmsLayer } from "../../layers/WmsLayer";
import { TreeCoverLayer } from "../../layers/TreeCoverLayer";

class BiodiversityDashboardLayerGroup extends BiodiversityLayerGroup {
  constructor(map = null, layer_group_data) {
    super(map, layer_group_data);

    this.id = this.id.replace(
      layer_group_data.uuid,
      `dashboard-${layer_group_data.uuid}`
    );

    this.has_dashboard = true;
    this.dashboard = ({ lang }) => <BiodiversityDashboard lang={lang} />;

    this.layers = this.createLayers();
  }

  createLayers = () => {
    const TYPE_MAP = {
      BIODIVERSITY_TREES: TreeCoverLayer,
    };
    const layers_to_add = [];

    for (const layer_data of this.layer_list_data) {
      const { layer_type } = layer_data;

      const layerClass = TYPE_MAP[layer_type] || WmsLayer;
      const new_layer = new layerClass(layer_data, this.id, this.map);

      layers_to_add.push(new_layer);
    }
    return layers_to_add;
  };
}

export default BiodiversityDashboardLayerGroup;
